window.klira.klaviyo = {
    trackCheckoutStarted: async function() {
        if (!window.customer.isLoggedIn()) {
            console.log('KLAVIYO_TRACK: Not logged in, cannot track checkout started.');
            return;
        }

        console.log('KLAVIYO_TRACK: Tracking checkout started');

        const responseJson = await window.utils.request.post(
            '/wp-json/klira/klaviyo/track/checkout-started',
            {
                items: window.cart.buildLineItems()
            }
        );

        console.log('KLAVIYO_TRACK: Response was parsed. ' + responseJson);
    },

    trackCheckoutCompleted: async function() {
        if (!window.customer.isLoggedIn()) {
            console.log('KLAVIYO_TRACK: Not logged in, cannot track checkout completed.');
            return;
        }

        console.log('KLAVIYO_TRACK: Tracking checkout completed');

        const responseJson = await window.utils.request.post(
            '/wp-json/klira/klaviyo/track/checkout-completed',
            {
                items: window.cart.buildLineItems()
            }
        );

        console.log('KLAVIYO_TRACK: Response was parsed. ' + responseJson);
    }
}